<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="false"
                        ></action-toolbar-buttons>
                        <div class="btn-group" *ngIf="canEdit">
                            <button type="button" class="btn btn-sm btn-secondary" (click)="deleteSelectedItem()" [disabled]="!grid.hasItemSelected">
                                <fa-icon class="d-none d-sm-inline-block" [icon]="faXmark"></fa-icon> Delete
                            </button>
                        </div>
                        <grid-export [grid]="mainGrid" [name]="'Leadership Team Visits'"></grid-export>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="leadershipTeamVisitsGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Visit Date'" [binding]="'visitDate'" [width]="130" [format]="'MM/dd/yyyy'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'jobName'" [width]="'2*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Visited By'" [binding]="'visitedByName'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="'2*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Observations'" [binding]="'observations'" [width]="'2*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Safety Feedback'" [binding]="'safetyFeedback'" [width]="'2*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
